import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/config";
import { HTTP_STATUS } from "../../app/constants";

const namespace = "navItem";

const initialState = {
  loading: null,
  navResponse: {},
  errorMessage: null,
};

// PATCH
export const updateUserCredential = createAsyncThunk(
  `${namespace}/updateUserCredential`,
  async (singninUser) => {
    const loginuser = singninUser;
    const response = await api.patch(`/signout/${loginuser}`);
    return response.data;
  }
);

export const navItemsSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(updateUserCredential.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(updateUserCredential.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.navResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(updateUserCredential.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.navResponse = {};
        state.errorMessage = error.message;
      });
  },
});

export const selectLoadingStatus = (state) => state.navItems.loading;
export default navItemsSlice.reducer;
